<template>
  <div />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    chartDataX: {
      type: Array,
    },
    chartDataY: {
      type: Array,
    },
    showDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      //解决数据还没初始化就初始化表格的bug
      setTimeout(() => {
        this.initChart();
      }, 200);
    });
    window.addEventListener("resize", this.windowResize);
  },
  methods: {
    windowResize() {
      //销毁图表重新画;
      setTimeout(() => {
        this.initChart();
      }, 100);
    },
    initChart() {
      if (this.$el.offsetHeight===0) {
        return;
      }
      echarts.dispose(this.$el);
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      if (!this.chart){
        return;
      }
      this.chart.setOption(
        {
          // title: {
          //   text: "负载",
          //   left: "2%",
          //   top: "1%",
          //   textStyle: { fontSize: "24px" },
          // },
          tooltip: {
            trigger: "axis",
            confine: true, //解决提示框越界
            formatter: (params) => {
              //自定义提示框
              let relVal = params[0].name;
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  "<br/>" + params[i].marker + params[i].value + " m / s";
              }
              return relVal;
            },
          },
          xAxis: {
            data: this.chartDataX,
            axisLine: {
              lineStyle: { color: "white" },
            },
            axisLabel: {
              color: 'white',
              // interval:'20',
              formatter: (params) => {
                let time = new Date(params);
                const y = time.getFullYear();
                const m = time.getMonth()+1;
                const d = time.getDate();
                const h = time.getHours();
                const mm = time.getMinutes();
                const s = time.getSeconds();
                if (this.showDate){
                  return (h<10?'0'+h:h)+':'+(mm<10?'0'+mm:mm)+'\n'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
                } else {
                  return (h<10?'0'+h:h)+':'+(mm<10?'0'+mm:mm);
                }
              }
            }
          },
          yAxis: {
            splitLine: {
              show: true,
              lineStyle: { color: ["#d6d6d65e"], width: 1, type: "dashed" },
            },
            axisLine: {
              lineStyle: { color: "white" },
            },
          },
          grid: {
            top: "30px",
            left: "15px",
            right: "15px",
            bottom: "5px",
            containLabel: true
          },
          series: {
            //   name: "负载",
            type: "line",
            center: [60, 60],
            data: this.chartDataY,
            showSymbol: false,
            itemStyle: {
              color: "#00d1ed",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00d1ed",
                },
                {
                  offset: 1,
                  color: "#00d1eda3",
                },
              ]),
            },
            //   markLine: {
            //     symbol: ["circle", "circle"], //去除样式
            //     data: this.showedLinesData,
            //     label: {
            //       formatter: (val) => {
            //         return this.showedLinesData[val.dataIndex].name;
            //       },
            //     },
            //   },
          },
        },
        true
      );
    },
  },
  watch: {
    chartDataX: {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lineEchart.vue